import { api } from './api';

export interface WompiCheckoutPayload {
  checkoutUrl: string;
  publicKey: string;
  currency: 'COP';
  amountInCents: number;
  reference: string;
  signature: string;
  redirectUrl?: string;
  expirationTime: string;
}

export interface PaymentInitiateResponse {
  /** Present when backend returns 200 from POST /payment/initiate */
  valid?: true;
  sessionId: string;
  paymentMode: 'simulation' | 'wompi';
  totalInCop: number;
  totalInDisplayCurrency: number;
  displayCurrency: string;
  wompiCheckout?: WompiCheckoutPayload;
  items: {
    cartItemId: string;
    productName: string;
    quantity: number;
    unitPriceCop: number;
    unitPriceDisplay: number;
    currencyDisplay: string;
  }[];
}

export interface PaymentConfirmResponse {
  orderId: string;
  order: unknown;
}

export interface WompiConfirmResponse {
  orderId?: string;
  order?: unknown;
  errorCode?: string;
  paymentStatus?: string;
  statusMessage?: string | null;
}

class PaymentService {
  async initiate(displayCurrency?: string, redirectUrl?: string): Promise<PaymentInitiateResponse> {
    return api.post<PaymentInitiateResponse>('/payment/initiate', {
      displayCurrency: displayCurrency ?? 'COP',
      redirectUrl,
    });
  }

  async confirm(
    sessionId: string,
    options?: { forceSuccess?: boolean; forceFailure?: boolean; forcePending?: boolean },
  ): Promise<PaymentConfirmResponse> {
    return api.post<PaymentConfirmResponse>('/payment/confirm', {
      sessionId,
      forceSuccess: options?.forceSuccess,
      forceFailure: options?.forceFailure,
      forcePending: options?.forcePending,
    });
  }

  async confirmWompi(transactionId: string): Promise<WompiConfirmResponse> {
    return api.post<WompiConfirmResponse>('/payment/wompi/confirm', {
      transactionId,
    });
  }
}

export const paymentService = new PaymentService();
